import styled from "styled-components";
import { useApp } from "../../contexts";
import { useState, useEffect } from "react";
import { MobileContainer } from "../Container";
import { languages } from "../../languages";
import { ArrowDownIcon } from "../Icons/ArrowDownIcon";
import { WalletMenuIcon } from "../Icons/WalletMenuIcon";
import { LanguageMenuIcon } from "../Icons/LanguageMenuIcon";
import { HomeMenuIcon } from "../Icons/HomeMenuIcon";
import { AssetMenuIcon } from "../Icons/AssetMenuIcon";
import { TradeMenuIcon } from "../Icons/TradeMenuIcon";
import { HelpMenuIcon } from "../Icons/HelpMenuIcon";
import { useNavigate } from "react-router-dom";
import environment from "../../environment";
import { LINKTR_URLS, ZENDESK_URLS } from "../../constants";

const Close = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-right: -8px;

  @media screen and (max-width: 1024px) {
    & > svg {
      width: 24px;
      height: 24px;
    }
  }
`;

const MContainer = styled.div`
  overflow: auto;
  position: fixed;
  z-index: 99;
  width: 100%;
  height: 100%;
  right: 0;
  top: 0px;
  background: #fff;
  padding: 14px 22px 20px;
`;

const MContainerBody = styled.div`
  margin: 2px 0 27px 0;
`;
const MContainerFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  bottom: 0;
`;

const MMenu = styled.div`
  min-height: calc(100vh - 129px);
`;
const MMenuSubTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 55px;
  position: relative;
  width: 100%;
  & > span {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    display: flex;
  }
  & > svg {
    width: 24px;
    height: 24px;
    margin-right: 18px;
  }
  & > .arrow-icon {
    position: absolute;
    right: 0;
    svg {
      width: 12px;
    }
    &.active {
      svg {
        transform: rotate(180deg);
      }
    }
  }
`;
const MMenuSubs = styled.div`
  display: none;
  &.active {
    display: block;
    width: 100%;
  }
`;
const MMenuSubItem = styled.a`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-style: normal;
  font-weight: 400;
  line-height: 35px;
  color: #000 !important;
  padding-left: 40px;
  font-size: 16px;
  gap: 16px;
  &:last-of-type {
    margin-bottom: 15px;
  }
`;

const MMenuSubItemLanguage = styled.a`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  line-height: 35px;
  color: #000000b2 !important;
  padding-left: 40px;
  height: 35px;
  font-size: 16px;
  gap: 16px;
  &:last-of-type {
    margin-bottom: 15px;
  }
`;
const MMenuItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 55px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  position: relative;
  &:last-of-type {
    border-bottom: none;
  }

  & > svg {
    width: 24px;
    height: 24px;
    margin-right: 18px;
  }

  & > span {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    display: flex;
  }

  & > .checker {
    position: absolute;
    right: 0;
    height: 24px;

    svg {
      height: 24px;
    }
  }
  &.hasSubs {
    flex-wrap: wrap;
    height: unset;
  }
`;
const HeaderLanguageSelectIcon = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    width: 24px;
    height: 24px;
  }
`;
const Mobile = (props) => {
  const { T, language, user, onSetLanguage } = useApp();
  const [groupMenuStatus, setGroupMenuStatus] = useState({
    trade: false,
    help: false,
    language: false,
  });
  const navigate = useNavigate();
  const handleRedirectAuth = (e, path) => {
    e.preventDefault();
    navigate(path);
    props?.onClose();
  };
  const handleRedirect = (e, path) => {
    e.preventDefault();
    props?.onClose();
    window.open(path, "_blank");
  };
  const handleToggleMenu = (e, key) => {
    e.preventDefault();
    const changeData = {};
    for (let item in groupMenuStatus) {
      if (item === key) {
        changeData[item] = !groupMenuStatus[item];
      } else {
        changeData[item] = false;
      }
    }
    setGroupMenuStatus(changeData);
  };
  const handleLanguage = (e, key) => {
    e.preventDefault();
    onSetLanguage(key);
  };
  const [linkHelp, $linkHelp] = useState(ZENDESK_URLS.EN.HELP);
  const [socialLink, $socialLink] = useState(LINKTR_URLS.EN);
  useEffect(() => {
    const lan = language;
    if (lan === "ja") {
      $linkHelp(ZENDESK_URLS.JA.HELP);
      $socialLink(LINKTR_URLS.JA);
    } else if (lan === "ko") {
      $linkHelp(ZENDESK_URLS.KO.HELP);
      $socialLink(LINKTR_URLS.KO);
    } else if (lan === "cn") {
      $linkHelp(ZENDESK_URLS.CN.HELP);
      $socialLink(LINKTR_URLS.CN);
    } else if (lan === "tc") {
      $linkHelp(ZENDESK_URLS.TC.HELP);
      $socialLink(LINKTR_URLS.TC);
    } else if (lan === "vi") {
      $linkHelp(ZENDESK_URLS.VI.HELP);
      $socialLink(LINKTR_URLS.VI);
    } else if (lan === "id") {
      $linkHelp(ZENDESK_URLS.ID.HELP);
      $socialLink(LINKTR_URLS.ID);
    } else if (lan === "pt") {
      $linkHelp(ZENDESK_URLS.PT.HELP);
      $socialLink(LINKTR_URLS.PT);
    } else if (lan === "es") {
      $linkHelp(ZENDESK_URLS.ES.HELP);
      $socialLink(LINKTR_URLS.ES);
    } else {
      $linkHelp(ZENDESK_URLS.EN.HELP);
      $socialLink(LINKTR_URLS.EN);
    }
  }, [language]);
  return (
    <MContainer>
      <div className="flex justify-end">
        <Close onClick={props.onClose}>
          <MCloseIcon />
        </Close>
      </div>
      <MContainerBody>
        <MMenu>
          <MMenuItem onClick={(e) => handleRedirectAuth(e, "/")}>
            <HomeMenuIcon />
            <span> {T("Home")}</span>
          </MMenuItem>
          <MMenuItem onClick={(e) => handleRedirectAuth(e, "/wallet")}>
            <WalletMenuIcon />
            <span> {T("Wallet")}</span>
          </MMenuItem>
          <MMenuItem onClick={(e) => handleRedirectAuth(e, "/asset")}>
            <AssetMenuIcon />
            <span> {T("Assets")}</span>
          </MMenuItem>
          <MMenuItem
            onClick={(e) => handleToggleMenu(e, "trade")}
            className="hasSubs"
          >
            <MMenuSubTitle>
              <TradeMenuIcon />
              <span> {T("Trade & Earn")}</span>
              <span
                className={`arrow-icon ${
                  groupMenuStatus.trade ? "active" : ""
                }`}
              >
                <ArrowDownIcon />
              </span>
            </MMenuSubTitle>
            <MMenuSubs className={groupMenuStatus.trade ? "active" : ""}>
              <MMenuSubItem
                onClick={(e) => handleRedirectAuth(e, "/stake-for-option")}
              >
                <M2StakeForOptionIcon />
                {T("Stake for option")}
              </MMenuSubItem>
              <MMenuSubItem onClick={(e) => handleRedirectAuth(e, "/stake")}>
                <M2StakeForVotingIcon />
                {T("Stake for voting")}
              </MMenuSubItem>
              <MMenuSubItem
                onClick={(e) => handleRedirect(e, `${user.store_shopify}?lang=${user.language}`)}
              >
                <M2MallIcon />
                {T("Mall")}
              </MMenuSubItem>
              <MMenuSubItem
                onClick={(e) =>
                  handleRedirect(
                    e,
                    `${environment.MARKETPLACE_URL}/marketplace?lang=${language}`
                  )
                }
              >
                <M2MarketIcon />
                {T("C2C market")}
              </MMenuSubItem>
            </MMenuSubs>
          </MMenuItem>
          <MMenuItem
            onClick={(e) => handleToggleMenu(e, "help")}
            className="hasSubs"
          >
            <MMenuSubTitle>
              <HelpMenuIcon />
              <span> {T("Help")}</span>
              <span
                className={`arrow-icon ${groupMenuStatus.help ? "active" : ""}`}
              >
                <ArrowDownIcon />
              </span>
            </MMenuSubTitle>
            <MMenuSubs className={groupMenuStatus.help ? "active" : ""}>
              <MMenuSubItem onClick={(e) => handleRedirect(e, linkHelp)}>
                <M2HelpIcon />
                {T("Help center")}
              </MMenuSubItem>
              <MMenuSubItem onClick={(e) => handleRedirect(e, socialLink)}>
                <M2SocialIcon />
                {T("Social media & Community")}
              </MMenuSubItem>
            </MMenuSubs>
          </MMenuItem>
          <MMenuItem
            onClick={(e) => handleToggleMenu(e, "language")}
            className="hasSubs"
          >
            <MMenuSubTitle>
              <LanguageMenuIcon />
              <span> {T("Language")}</span>
              <span
                className={`arrow-icon flex gap-[10px] items-center ${
                  groupMenuStatus.language ? "active" : ""
                }`}
              >
                <span className="uppercase">{language}</span>
                <ArrowDownIcon />
              </span>
            </MMenuSubTitle>
            <MMenuSubs className={groupMenuStatus.language ? "active" : ""}>
              {languages.map((language, index) => {
                return (
                  <MMenuSubItemLanguage
                    key={index}
                    onClick={(e) => handleLanguage(e, language.id)}
                  >
                    <HeaderLanguageSelectIcon>
                      {language.icon()}
                    </HeaderLanguageSelectIcon>
                    <span>{language.name}</span>
                  </MMenuSubItemLanguage>
                );
              })}
            </MMenuSubs>
          </MMenuItem>
          {/* <MMenuItem
            onClick={() => {
              onCheck2FA();
              props.onClose();
            }}
          >
            <TwoFAAuthenticationMenuIcon />
            <span>{T("2FA Authentication")}</span>
            <div className={"checker"}>
              {!!user?.is_twofa ? <CheckedIcon /> : <UnCheckIcon />}
            </div>
          </MMenuItem> */}
        </MMenu>
      </MContainerBody>
      <MContainerFooter>
        {T("© 2025 AI Avatar Pte. Ltd. All rights reserved.")}
      </MContainerFooter>
    </MContainer>
  );
};

export default function Sidebar(props) {
  return (
    <>
      <MobileContainer>
        <Mobile {...props} />
      </MobileContainer>
    </>
  );
}

const MCloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.4404 3.22021L3.44043 20.2202"
      stroke="#666666"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.44043 3.22021L20.4404 20.2202"
      stroke="#666666"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
const M2MallIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
  >
    <path
      d="M14.9253 3.81692C14.9253 2.65912 13.9831 1.71692 12.8253 1.71692H3.02529C1.86749 1.71692 0.925293 2.65912 0.925293 3.81692V5.79862C0.925293 6.53572 1.19269 7.20562 1.62529 7.72082V13.6169C1.62529 14.389 2.25319 15.0169 3.02529 15.0169H5.82529H10.0253H12.8253C13.5974 15.0169 14.2253 14.389 14.2253 13.6169V7.72012C14.6579 7.20562 14.9253 6.53572 14.9253 5.79792V3.81692ZM13.5253 3.81692V5.79862C13.5253 6.59662 12.931 7.27702 12.2016 7.31552L12.1253 7.31692C11.3532 7.31692 10.7253 6.68902 10.7253 5.91692V3.11692H12.8253C13.2117 3.11692 13.5253 3.43122 13.5253 3.81692ZM6.52529 3.11692H9.32529V5.91692C9.32529 6.68902 8.69739 7.31692 7.92529 7.31692C7.15319 7.31692 6.52529 6.68902 6.52529 5.91692V3.11692ZM2.32529 3.81692C2.32529 3.43122 2.63889 3.11692 3.02529 3.11692H5.12529V5.91692C5.12529 6.68902 4.49739 7.31692 3.72529 7.31692L3.64899 7.31482C2.91959 7.27702 2.32529 6.59662 2.32529 5.79862V3.81692ZM6.52529 13.6169V11.5169H9.32529V13.6169H6.52529ZM10.7253 13.6169V11.5169C10.7253 10.7448 10.0974 10.1169 9.32529 10.1169H6.52529C5.75319 10.1169 5.12529 10.7448 5.12529 11.5169V13.6169H3.02529V8.62522C3.20309 8.67212 3.38719 8.70292 3.57619 8.71272C4.47289 8.75962 5.28209 8.38302 5.82529 7.76702C6.33839 8.34942 7.09019 8.71692 7.92529 8.71692C8.76039 8.71692 9.51219 8.34942 10.0253 7.76702C10.5685 8.38302 11.3791 8.76032 12.2744 8.71272C12.4641 8.70292 12.6475 8.67212 12.8253 8.62522V13.6169H10.7253Z"
      fill="#AAAAAA"
    />
  </svg>
);
const M2MarketIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.12791 1.05C2.33729 1.2625 1.84666 2.08437 2.04666 2.85938C2.18729 3.39062 2.60604 3.81562 3.13416 3.95C3.29041 3.99062 3.27791 3.99375 2.73416 4.00312C2.18104 4.01562 2.16854 4.01875 1.96229 4.11562C1.45291 4.35625 1.12479 4.87188 1.02791 5.57812C1.01229 5.71562 0.999788 6.13437 1.00604 6.50625C1.01541 7.25 1.01854 7.2625 1.23104 7.41875C1.31541 7.48438 1.34354 7.48438 3.49979 7.48438C5.65604 7.48438 5.68416 7.48438 5.76854 7.41875C5.81541 7.38437 5.88416 7.31562 5.91854 7.26875C5.98104 7.1875 5.98416 7.14375 5.98104 6.33438C5.98104 5.5 5.97791 5.47812 5.89354 5.20312C5.72791 4.6625 5.47479 4.33437 5.06854 4.13437L4.83104 4.01562L4.26854 4.00312C3.71541 3.99375 3.70604 3.99062 3.87166 3.95C4.65604 3.74688 5.15291 2.91563 4.95291 2.14687C4.74354 1.3375 3.91229 0.8375 3.12791 1.05Z"
      fill="#AAAAAA"
    />
    <path
      d="M6.79645 3.54376C6.5027 3.67501 6.40895 4.07189 6.6152 4.31564C6.7652 4.49064 6.8152 4.50001 7.7902 4.50001C8.48395 4.50001 8.71207 4.50939 8.85895 4.54689C9.54645 4.72814 9.99957 5.32814 9.99957 6.05626V6.29064L9.86207 6.16251C9.63082 5.95001 9.35895 5.94689 9.1527 6.15314C9.02457 6.28126 8.98082 6.42814 9.0152 6.61564C9.03082 6.71564 9.1277 6.82814 9.64957 7.35001C10.3121 8.01251 10.3464 8.03439 10.6183 7.98439C10.7152 7.96876 10.8277 7.87189 11.3496 7.35001C11.8714 6.82814 11.9683 6.71564 11.9839 6.61564C12.0183 6.42814 11.9746 6.28126 11.8464 6.15314C11.6433 5.94689 11.3683 5.95001 11.1402 6.15939L11.0089 6.28126L10.9902 5.92814C10.9652 5.40939 10.8496 5.03439 10.5964 4.65001C10.2402 4.10626 9.76832 3.76564 9.09332 3.56876C8.8527 3.50001 6.9402 3.47814 6.79645 3.54376Z"
      fill="#AAAAAA"
    />
    <path
      d="M5.29643 8.04375C5.24643 8.06875 4.94018 8.35313 4.61831 8.675C4.12768 9.17188 4.03393 9.28437 4.01518 9.38125C3.98081 9.57187 4.02456 9.71875 4.15268 9.84687C4.35581 10.0531 4.63081 10.05 4.85893 9.84063L4.99018 9.71875L5.00893 10.0719C5.03393 10.5906 5.14956 10.9656 5.40268 11.35C5.67768 11.7688 6.14331 12.1594 6.55581 12.3125C6.99956 12.4812 7.04018 12.4844 8.14643 12.4844C9.14331 12.4844 9.18706 12.4812 9.26831 12.4187C9.43393 12.2969 9.48393 12.1969 9.48393 12C9.48393 11.8031 9.43393 11.7031 9.26831 11.5813C9.18706 11.5188 9.13081 11.5156 8.17768 11.5C7.24643 11.4844 7.15893 11.4781 7.00893 11.4156C6.74643 11.3094 6.58706 11.2062 6.41518 11.025C6.14018 10.7312 5.99956 10.3687 5.99956 9.94375V9.70937L6.13706 9.8375C6.36831 10.05 6.64018 10.0531 6.84643 9.84687C6.97456 9.71875 7.01831 9.57187 6.98393 9.38125C6.96518 9.28437 6.87143 9.17188 6.38081 8.675C6.05893 8.35313 5.75268 8.06875 5.69643 8.04375C5.57143 7.99062 5.41831 7.99062 5.29643 8.04375Z"
      fill="#AAAAAA"
    />
    <path
      d="M12.1279 8.55C11.3373 8.7625 10.8467 9.58437 11.0467 10.3594C11.1873 10.8906 11.606 11.3156 12.1342 11.45C12.2904 11.4906 12.2779 11.4937 11.7342 11.5031C11.181 11.5156 11.1685 11.5187 10.9623 11.6156C10.4529 11.8563 10.1248 12.3719 10.0279 13.0781C10.0123 13.2156 9.99979 13.6344 10.006 14.0062C10.0154 14.75 10.0185 14.7625 10.231 14.9187C10.3154 14.9844 10.3435 14.9844 12.4998 14.9844C14.656 14.9844 14.6842 14.9844 14.7685 14.9187C14.8154 14.8844 14.8842 14.8156 14.9185 14.7687C14.981 14.6875 14.9842 14.6437 14.981 13.8344C14.981 13 14.9779 12.9781 14.8935 12.7031C14.7279 12.1625 14.4748 11.8344 14.0685 11.6344L13.831 11.5156L13.2685 11.5031C12.7154 11.4937 12.706 11.4906 12.8717 11.45C13.656 11.2469 14.1529 10.4156 13.9529 9.64687C13.7435 8.8375 12.9123 8.3375 12.1279 8.55Z"
      fill="#AAAAAA"
    />
  </svg>
);
const M2HelpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <g clip-path="url(#clip0_19081_38818)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.61442 13.99C9.61442 13.441 9.166 12.9961 8.61312 12.9961H7.38688C7.12142 12.9961 6.86671 13.1008 6.67887 13.2872C6.49104 13.4737 6.38558 13.7263 6.38558 13.99C6.38558 14.5389 6.834 14.9839 7.38688 14.9839H8.61312C9.166 14.9839 9.61442 14.5389 9.61442 13.99ZM2.105 11.4271C2.27229 11.4398 2.47462 11.4471 2.67792 11.4353C2.78612 11.9804 3.05517 12.4859 3.45671 12.8844C3.98975 13.4135 4.71271 13.7108 5.46663 13.7108H5.84863C5.83171 13.8023 5.82308 13.8956 5.82308 13.99C5.82308 14.0853 5.83171 14.1787 5.84829 14.2691H5.46663C4.56346 14.2691 3.69742 13.9131 3.05892 13.2793C2.5495 12.7736 2.21825 12.1242 2.105 11.4271ZM1.81883 10.833C1.37483 10.7587 0.961583 10.5492 0.639 10.229C0.229833 9.82282 0 9.2721 0 8.69776V7.37802C0 6.80384 0.229833 6.25295 0.639 5.84694C1.048 5.44081 1.60304 5.21267 2.18163 5.21267H2.32683C2.55892 2.30437 5.01025 0.0161133 8 0.0161133C10.9897 0.0161133 13.4411 2.30437 13.6732 5.21267H13.8184C14.397 5.21267 14.952 5.44081 15.361 5.84694C15.7702 6.25295 16 6.80384 16 7.37802V8.69776C16 9.2721 15.7702 9.82282 15.361 10.229C14.952 10.635 14.397 10.8632 13.8184 10.8632H13.1746C12.9075 10.8632 12.6912 10.6484 12.6912 10.3833V5.66521C12.6912 3.0934 10.5908 1.00871 8 1.00871C5.40917 1.00871 3.30875 3.0934 3.30875 5.66521V10.3833C3.30875 10.5705 3.20083 10.7325 3.04346 10.8117C2.61004 10.961 1.938 10.8529 1.81883 10.833Z"
        fill="#AAAAAA"
      />
    </g>
    <defs>
      <clipPath id="clip0_19081_38818">
        <rect
          width="16"
          height="14.9677"
          fill="white"
          transform="translate(0 0.0161133)"
        />
      </clipPath>
    </defs>
  </svg>
);
const M2SocialIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <g clip-path="url(#clip0_19114_2105)">
      <path
        d="M7.95312 0.537499C7.86875 0.553124 7.67812 0.621875 7.53438 0.690625C7.075 0.915625 6.7375 1.32812 6.60938 1.82812C6.57188 1.97812 6.5625 2.25937 6.5625 3.375V4.73438L4.18125 4.725C2.5375 4.71875 1.75 4.72812 1.6375 4.75C1.20312 4.84062 0.828125 5.14062 0.63125 5.55312C0.515625 5.79688 0.515625 5.8 0.50625 6.26875C0.49375 6.71875 0.496875 6.74687 0.559375 6.80937C0.65625 6.90625 0.821875 6.89687 0.903125 6.79375C0.9625 6.71875 0.96875 6.66875 0.96875 6.34062C0.96875 6.04375 0.98125 5.9375 1.03438 5.79688C1.10938 5.59375 1.30625 5.38437 1.52188 5.27812L1.67188 5.20312H4.0625H6.45312L6.61562 5.27812C6.81875 5.36875 7.03438 5.59375 7.1125 5.79688C7.16875 5.94687 7.17188 6.05937 7.17188 8.23438V10.5156L6.78125 10.5312C6.43438 10.5437 6.37188 10.5563 6.2125 10.6344C5.98125 10.7469 5.77187 10.9812 5.68438 11.2188C5.61875 11.3969 5.60625 11.4125 5.1 11.8031C4.81563 12.0219 4.57188 12.2062 4.55938 12.2125C4.54688 12.2188 4.53125 12.0687 4.525 11.8812C4.50938 11.3625 4.65938 11.4125 3.06875 11.4C1.88437 11.3875 1.71875 11.3812 1.5875 11.3312C1.39062 11.2594 1.17188 11.0594 1.06875 10.8625L0.984375 10.7031L0.96875 9.34062C0.953125 8.05312 0.95 7.97188 0.89375 7.90938C0.815625 7.825 0.646875 7.82187 0.5625 7.90625C0.503125 7.96562 0.5 8.00937 0.5 9.30937C0.5 10.775 0.50625 10.8406 0.696875 11.1625C0.8125 11.3625 1.09688 11.6156 1.32188 11.7219C1.60312 11.85 1.84063 11.8719 3.025 11.875H4.0625V12.3531C4.0625 12.8719 4.07188 12.9 4.24063 12.95C4.33438 12.9813 4.37188 12.9562 4.99062 12.4781C5.29063 12.2469 5.55312 12.0531 5.57812 12.0437C5.61562 12.0281 5.625 12.2375 5.63125 13.4906L5.64062 14.9531L5.72813 15.1187C5.84375 15.3375 6.03125 15.5188 6.24688 15.6219C6.42188 15.7031 6.42812 15.7031 7.275 15.7125L8.125 15.7219V16C8.125 16.1531 8.14062 16.3125 8.15938 16.3531C8.19688 16.4344 8.30625 16.5 8.4 16.5C8.42812 16.5 8.67813 16.325 8.95625 16.1125L9.45625 15.7281L9.7375 15.7125C10.2156 15.6906 10.5344 15.4844 10.7281 15.0719C10.8156 14.8813 10.8219 14.8406 10.825 14.4937C10.8281 14.1375 10.825 14.1156 10.7531 14.0594C10.6656 13.9875 10.5375 13.9813 10.45 14.0469C10.3906 14.0844 10.3813 14.1312 10.3688 14.4437C10.35 14.825 10.3188 14.925 10.1656 15.0688C10.025 15.2031 9.875 15.25 9.58125 15.25H9.31563L8.9625 15.5156L8.60938 15.7844L8.6 15.5813C8.59375 15.4062 8.58125 15.3687 8.50938 15.3125C8.43125 15.2531 8.3875 15.25 7.50313 15.25C6.66875 15.25 6.56563 15.2437 6.45312 15.1906C6.30625 15.1219 6.175 14.9906 6.12813 14.8656C6.10625 14.8062 6.09375 14.2094 6.09375 13.1063C6.09375 11.5281 6.09688 11.4281 6.15313 11.3187C6.22188 11.1875 6.2875 11.1219 6.42812 11.05C6.51562 11.0062 6.72188 11 8.21875 11C9.71562 11 9.92188 11.0062 10.0094 11.05C10.1531 11.1219 10.2156 11.1875 10.2906 11.3281C10.3531 11.4437 10.3594 11.5125 10.3688 12.1562C10.3813 12.9469 10.3875 12.9688 10.5938 12.9688C10.6719 12.9688 10.7281 12.9469 10.7688 12.9031C10.825 12.8406 10.8281 12.7812 10.825 12.1125C10.825 11.4313 10.8219 11.3812 10.75 11.2031C10.65 10.95 10.3938 10.6906 10.1469 10.6C9.975 10.5344 9.91875 10.5312 8.8125 10.5312H7.65625V9.91875C7.65625 9.34687 7.65938 9.30625 7.7125 9.32812C7.94688 9.42188 8.20625 9.4375 9.55625 9.4375H10.9375V10.0594V10.6844L11.0188 10.7469C11.0656 10.7844 11.1344 10.8125 11.1719 10.8125C11.2188 10.8125 11.575 10.5594 12.1313 10.1312L13.0156 9.45312L13.5469 9.43437C14.0094 9.41875 14.1094 9.40312 14.3094 9.33437C14.7344 9.18437 15.0969 8.87812 15.2937 8.5C15.5094 8.09375 15.5031 8.20937 15.4938 4.86562L15.4844 1.85938L15.3938 1.64062C15.2063 1.18437 14.9094 0.865624 14.4844 0.66875C14.1906 0.534375 13.9812 0.5 13.4313 0.5C13.0094 0.5 12.9625 0.506249 12.9062 0.5625C12.8219 0.646874 12.8219 0.821875 12.9125 0.90625C12.975 0.9625 13.0219 0.96875 13.4375 0.96875C14.1062 0.96875 14.3594 1.05 14.6687 1.36562C14.75 1.44687 14.8594 1.60312 14.9156 1.71562L15.0156 1.92188V4.96875V8.01562L14.9156 8.22188C14.8031 8.45 14.5594 8.70312 14.35 8.80937C14.1062 8.93437 13.8906 8.96875 13.3719 8.96875H12.8813L12.1531 9.52812L11.4219 10.0875L11.4062 9.5875C11.3906 9.10938 11.3875 9.08437 11.3156 9.02812C11.2469 8.97187 11.1719 8.96875 9.73125 8.96875C8.175 8.96875 8.00625 8.95625 7.775 8.84062L7.65625 8.78125V7.40625C7.65625 6.51875 7.64375 5.975 7.62188 5.86875C7.56563 5.6 7.44063 5.375 7.22813 5.15312L7.02813 4.94687L7.0375 3.43437L7.04688 1.92188L7.14375 1.71875C7.24688 1.49687 7.4625 1.2625 7.66563 1.14062C7.95312 0.974999 8.02187 0.96875 9.92813 0.96875C11.6469 0.96875 11.6875 0.96875 11.75 0.90625C11.7875 0.86875 11.8125 0.803124 11.8125 0.734375C11.8125 0.665625 11.7875 0.599999 11.75 0.5625C11.6875 0.5 11.6469 0.5 9.9 0.503125C8.91563 0.506249 8.04063 0.51875 7.95312 0.537499Z"
        fill="#AAAAAA"
      />
      <path
        d="M11.2812 2.275C11.125 2.35938 11.0375 2.50312 11.0156 2.7125C10.9875 2.99062 10.9125 3.25312 10.8156 3.40625C10.7656 3.48438 10.5687 3.725 10.375 3.94375C10.0656 4.29375 10.0187 4.3375 9.97812 4.29688C9.94062 4.25937 9.80312 4.25 9.1875 4.25C8.45312 4.25 8.44062 4.25 8.39375 4.31875C8.35 4.38125 8.34375 4.58125 8.34375 5.89688C8.34375 7.36562 8.34687 7.40937 8.40625 7.46875C8.46562 7.52812 8.50937 7.53125 9.19687 7.53125C9.88437 7.53125 9.93125 7.52812 9.98437 7.46875C10.0375 7.40937 10.0406 7.40937 10.1531 7.46563C10.4812 7.63437 10.5469 7.64062 11.9531 7.64062C13.2562 7.64062 13.2656 7.64062 13.3969 7.56875C13.4719 7.53125 13.5687 7.44062 13.6156 7.36875L13.7031 7.2375L13.7125 5.9875C13.7187 5.29688 13.7125 4.6875 13.7031 4.63125C13.6781 4.5 13.5187 4.31875 13.3594 4.24688C13.2531 4.19687 13.1469 4.1875 12.5969 4.1875C12.0031 4.1875 11.9625 4.18438 11.9844 4.13125C12.1437 3.75312 12.1875 3.35625 12.1125 3C12.05 2.70312 11.9 2.39687 11.775 2.30937C11.6406 2.2125 11.4219 2.19688 11.2812 2.275ZM11.5719 2.83125C11.6031 2.89062 11.6437 3.0375 11.6625 3.15625C11.7094 3.43437 11.6656 3.69062 11.4969 4.08125C11.4312 4.24062 11.375 4.4 11.375 4.4375C11.375 4.47187 11.4094 4.5375 11.4531 4.57812L11.5281 4.65625H12.3531C12.95 4.65625 13.1844 4.66562 13.2125 4.69375C13.2406 4.72187 13.25 5.0375 13.25 5.92813C13.25 7.07812 13.2469 7.125 13.1906 7.15625C13.1094 7.19688 10.9875 7.19688 10.7219 7.15625C10.5125 7.12187 10.3344 7.04375 10.1656 6.91562L10.0625 6.84062V5.92188V5.00625L10.6094 4.38437C10.9656 3.98125 11.1937 3.69375 11.2625 3.5625C11.3844 3.33125 11.4687 3.0375 11.4687 2.84687C11.4687 2.69062 11.5031 2.68437 11.5719 2.83125ZM9.59375 5.89062V7.0625H9.20312H8.8125V5.89062V4.71875H9.20312H9.59375V5.89062Z"
        fill="#AAAAAA"
      />
      <path
        d="M3.6438 6.62188C3.59693 6.67188 3.54693 6.91562 3.43755 7.58437C3.43755 7.59063 3.21255 7.59375 2.94068 7.59375C2.46568 7.59375 2.43755 7.59687 2.36255 7.6625C2.25005 7.76562 2.24068 7.89687 2.3438 8C2.40005 8.05625 2.44693 8.0625 2.87505 8.0625H3.3438V8.14687C3.34068 8.19687 3.32505 8.325 3.30318 8.4375L3.26568 8.64062L2.82818 8.65C2.3313 8.65937 2.2813 8.68125 2.2813 8.875C2.2813 9.075 2.35005 9.10625 2.80005 9.12187C3.01255 9.125 3.18755 9.13437 3.18755 9.1375C3.18755 9.1375 3.15943 9.30312 3.12505 9.5C3.09068 9.69688 3.06255 9.89687 3.06255 9.94062C3.06255 10.0469 3.18443 10.1562 3.30318 10.1562C3.45943 10.1562 3.50318 10.075 3.5813 9.60312C3.62193 9.36562 3.6563 9.1625 3.6563 9.14688C3.6563 9.13437 3.78443 9.125 3.93755 9.125C4.12193 9.125 4.2188 9.1375 4.2188 9.15938C4.2188 9.17812 4.18755 9.36875 4.15318 9.58437C4.08755 9.975 4.08755 9.975 4.14693 10.0594C4.2313 10.1688 4.38755 10.1844 4.48443 10.0938C4.5438 10.0375 4.5688 9.95 4.62818 9.575L4.70005 9.125H5.1563C5.63443 9.125 5.7938 9.09687 5.8438 9C5.88755 8.91875 5.8813 8.80313 5.8313 8.73125C5.79068 8.67813 5.73443 8.66875 5.29068 8.65625C4.72505 8.6375 4.77818 8.68125 4.8438 8.2875L4.8813 8.0625H5.30943C5.7188 8.0625 5.7438 8.05938 5.8063 7.99062C5.89693 7.89375 5.8938 7.76562 5.79693 7.67188C5.72505 7.59687 5.70318 7.59375 5.3438 7.59375C5.11255 7.59375 4.9688 7.58125 4.9688 7.5625C4.9688 7.54375 4.99693 7.35312 5.0313 7.13437C5.0938 6.74375 5.0938 6.73438 5.03755 6.65625C4.94068 6.52813 4.71255 6.53437 4.65318 6.66562C4.63755 6.70312 4.59068 6.925 4.55318 7.15625L4.4813 7.57812L4.20005 7.5875L3.91568 7.59687L3.97193 7.25937C4.04693 6.825 4.04693 6.68125 3.97505 6.61562C3.89693 6.54375 3.70943 6.54688 3.6438 6.62188ZM4.4063 8.06875C4.4063 8.11875 4.30943 8.60312 4.29693 8.625C4.28755 8.64375 4.15943 8.65625 4.01255 8.65625C3.7188 8.65625 3.7313 8.67188 3.7813 8.3875C3.8438 8.02813 3.80943 8.0625 4.12505 8.0625C4.2813 8.0625 4.4063 8.06562 4.4063 8.06875Z"
        fill="#AAAAAA"
      />
      <path
        d="M7.35 12.1125C7.175 12.2 7.06875 12.3094 6.95938 12.5125C6.90313 12.6156 6.89062 12.6938 6.89062 12.9219C6.89062 13.1781 6.9 13.225 6.99375 13.4125C7.06562 13.5625 7.15625 13.6781 7.30938 13.8188C7.51875 14.0125 7.92188 14.275 8.11875 14.35C8.24375 14.3969 8.325 14.3719 8.66562 14.1656C9.03125 13.9469 9.31875 13.6656 9.44375 13.4125C9.5375 13.225 9.54688 13.1781 9.54688 12.9219C9.54688 12.6688 9.5375 12.625 9.45312 12.4719C9.35625 12.2969 9.17813 12.1406 8.99063 12.0719C8.8125 12.0063 8.52813 12.0219 8.36563 12.1063L8.21875 12.1781L8.07187 12.1063C7.8625 12 7.57188 12.0031 7.35 12.1125ZM7.9875 12.6469C8.09063 12.7594 8.14375 12.7906 8.21875 12.7906C8.29375 12.7906 8.34688 12.7594 8.45 12.6469C8.56875 12.5156 8.6 12.5 8.71563 12.5C8.81875 12.5 8.86875 12.5219 8.9625 12.6063C9.075 12.7125 9.07812 12.7188 9.07812 12.9313C9.07812 13.125 9.06562 13.1656 8.98438 13.2875C8.87188 13.4438 8.59688 13.6719 8.375 13.7938L8.21875 13.8781L8.06875 13.7969C7.84688 13.6781 7.575 13.4563 7.46875 13.3094C7.30312 13.0813 7.30625 12.7625 7.47188 12.5938C7.55 12.5156 7.59375 12.5 7.70938 12.5C7.84062 12.5 7.86563 12.5125 7.9875 12.6469Z"
        fill="#AAAAAA"
      />
    </g>
    <defs>
      <clipPath id="clip0_19114_2105">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
const M2StakeForVotingIcon = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2405 15.3724L16.0291 8.09998C15.9857 7.84005 15.7609 7.64955 15.4974 7.64955H14.5545L16.3682 4.50813C16.4397 4.38433 16.459 4.23722 16.422 4.09913C16.385 3.96105 16.2947 3.84331 16.1709 3.77186L9.76299 0.0722152C9.63919 0.000731255 9.49212 -0.0186388 9.354 0.0183833C9.21591 0.0553717 9.09818 0.14572 9.02673 0.26952L4.76589 7.64951H1.75042C1.48692 7.64951 1.26206 7.84001 1.21874 8.09994L0.00731915 15.3724C-0.0186873 15.5287 0.0253417 15.6885 0.12775 15.8094C0.230159 15.9303 0.380572 16 0.539002 16H16.7088C16.8672 16 17.0176 15.9303 17.12 15.8094C17.2225 15.6885 17.2665 15.5287 17.2405 15.3724ZM9.69077 1.27528L15.1651 4.4359L11.2104 11.2857H7.78277L4.87914 9.60933L9.69077 1.27528ZM1.17522 14.922L2.20705 8.7275H4.14352L3.67608 9.53714C3.52725 9.79494 3.61557 10.1246 3.87335 10.2734L5.62676 11.2857H3.55019C3.25253 11.2857 3.01119 11.5271 3.01119 11.8247C3.01119 12.1224 3.25253 12.3637 3.55019 12.3637H13.6976C13.9953 12.3637 14.2366 12.1224 14.2366 11.8247C14.2366 11.5271 13.9953 11.2857 13.6976 11.2857H12.4551L13.9321 8.7275H15.0407L16.0726 14.922H1.17522Z"
      fill="#AAAAAA"
    />
  </svg>
);
const M2StakeForOptionIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.90374 1.23014C2.43173 1.23014 1.23844 2.42343 1.23844 3.89545V12.0963C1.23844 13.5684 2.43173 14.7616 3.90374 14.7616H12.1046C13.5766 14.7616 14.7699 13.5684 14.7699 12.0963V3.89545C14.7699 2.42343 13.5766 1.23014 12.1046 1.23014H3.90374ZM0.00830078 3.89545C0.00830078 1.74404 1.75234 0 3.90374 0H12.1046C14.256 0 16.0001 1.74404 16.0001 3.89545V12.0963C16.0001 14.2477 14.256 15.9918 12.1046 15.9918H3.90374C1.75234 15.9918 0.00830078 14.2477 0.00830078 12.0963V3.89545Z"
      fill="#AAAAAA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0675 4.84414C10.3336 5.05523 10.3783 5.44213 10.1672 5.70828L6.73919 10.0301C6.54035 10.2808 6.18243 10.3372 5.91613 10.1597L3.71005 8.68895L1.10055 12.043C0.891954 12.3111 0.505514 12.3594 0.237408 12.1508C-0.0306978 11.9422 -0.0789439 11.5558 0.129648 11.2876L3.09016 7.48243C3.28802 7.22809 3.64864 7.16958 3.91676 7.34835L6.12732 8.82205L9.2034 4.94383C9.41449 4.67767 9.80139 4.63304 10.0675 4.84414Z"
      fill="#AAAAAA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.83154 5.22444C6.83154 4.88473 7.1069 4.60938 7.44661 4.60938H10.0381C10.3778 4.60938 10.6531 4.88473 10.6531 5.22444V7.80773C10.6531 8.14739 10.3778 8.4228 10.0381 8.4228C9.6984 8.4228 9.423 8.14739 9.423 7.80773V5.83951H7.44661C7.1069 5.83951 6.83154 5.56411 6.83154 5.22444Z"
      fill="#AAAAAA"
    />
  </svg>
);
